import { ABScreen } from '../lib/ab/screen';
import { abGetDefaultCity } from '../lib/ab/widgets-home';
import '../lib/blk/all';
import { blkMakeSection } from '../lib/blk/render';
import { aTrackPage } from '../lib/mdl/a-track';
import { cPlanDiscountedPrice } from '../lib/mdl/c-plan';
import { f_pages } from '../lib/mdl/f-page';
import { the_login_scope, the_user } from '../lib/me/login';
import { getCountry } from '../lib/me/me';
import { registerFieldProvider } from '../lib/ui/component/field-tag';
import { UIRibbon } from '../lib/ui/component/ribbon';
import { UIViewSpec } from '../lib/ui/view';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $format } from '../lib/y/format';
import { yGetI18N, yInterpolate, ySetLanguageOneOf } from '../lib/y/i18n';
import { YId } from '../lib/y/types';
import { HomeMenu } from './menu';
import { HomeReferralPopup, HomeVerifyDialog } from './signup';

let referral_popup_shown = false;
let onboarding_shown = false;
let trustly_popup_shown = false;

export class HomeCustomScreen extends ABScreen {
    constructor(private _page_id: YId, private _onboarding: boolean, preview: boolean) {
        super({});

        if(preview)
            this.ui_add(new UIRibbon('PREVIEW'));
    }

    protected override fillContent(content: UIViewSpec): Promise<any> {
        const promise = f_pages.get(this._page_id).then(page => {
            const languages = Object.keys(page.languages);
            ySetLanguageOneOf(languages);
            this.ab_footer?.setLanguages(languages);

            registerFieldProvider(this, f => {
                if(f == 'user.city') {
                    return abGetDefaultCity().name;
                } else if(f == 'promo.button') {
                    const promo = window.ab_signup_promo;
                    const standard = window.ab_plans[0];
                    const plusone = window.ab_plans[1]
                    return yInterpolate(yGetI18N(promo.texts.hero_button), $format.currency(standard.price[getCountry()]), $format.currency(cPlanDiscountedPrice(standard, promo)), $format.currency(plusone.price[getCountry()]), $format.currency(cPlanDiscountedPrice(plusone, promo)));
                } else if(f == 'promo.subtitle') {
                    const promo = window.ab_signup_promo;
                    const standard = window.ab_plans[0];
                    const plusone = window.ab_plans[1]
                    return yInterpolate(yGetI18N(promo.texts.hero_subtitle), $format.currency(standard.price[getCountry()]), $format.currency(cPlanDiscountedPrice(standard, promo)), $format.currency(plusone.price[getCountry()]), $format.currency(cPlanDiscountedPrice(plusone, promo)));
                }

                return undefined;
            });

            const promises: Promise<any>[] = [];
            const sections = page.sections.filter(s => !(Object.keys(s.countries).length && !s.countries[getCountry()]));
            content.ui_add(sections.map((s, n) => blkMakeSection(s, n, this, promises, page.flags, () => new HomeMenu)));

            if(!the_login_scope && window.ab_referral_user && !referral_popup_shown) {
                referral_popup_shown = true;
                new HomeReferralPopup(window.ab_referral_user).present();
            }

            return promises.length ? Promise.all(promises) : undefined;
        });

        aTrackPage('custom', { landing_page: this._page_id });
        if(this._onboarding && the_login_scope && !onboarding_shown) {
            onboarding_shown = true;
            // new home_onboarding.OnboardingDialog().present();
        } else if(the_login_scope && !the_user!.phone) {
            new HomeVerifyDialog().present();
        } else if(xavis_experiments && the_login_scope && the_user!.payment_method?.provider == 'trustly' && !trustly_popup_shown) {
            trustly_popup_shown = true;
            $log('app', 'Showing Trustly popup');
            // new home_trustly.TrustlyPopup().present();
        }

        return promise;
    }
}
